import { useEffect } from 'react';

export interface ReselectEvent extends CustomEvent {
    detail: {
        // relative to pageIndex; only for a target that can select across pages a y below 0 or above 1 lies on the
        // previous or next pages, otherwise the bbox is clamped to that page
        bbox: number[][];
        pageIndex: number;
        itemIndex?: number;
        isEmailOcr?: boolean;
    };
}

const useReselectEventListener = (ref: any, callback: (event: ReselectEvent) => void) => {
    useEffect(() => {
        const listener = (event: ReselectEvent) => callback(event);

        ref.current?.addEventListener('reselect', listener);
        return () => {
            ref.current?.removeEventListener('reselect', listener);
        };
    }, [callback, ref]);
};

export default useReselectEventListener;
